import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { ThemeProvider } from '@mui/material';
import { useRtl } from './useRtl';
var EmbersInnerThemeProvider = function EmbersInnerThemeProvider(_ref) {
  var _theme = _ref.theme,
    children = _ref.children;
  var _useRtl = useRtl(),
    dir = _useRtl.dir;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: function theme(outerTheme) {
      return _objectSpread(_objectSpread(_objectSpread({}, outerTheme), typeof _theme !== 'function' ? _theme || {} : _theme(outerTheme)), {}, {
        direction: dir
      });
    }
  }, children);
};
export { EmbersInnerThemeProvider };